import React, {useCallback, useMemo, useState} from "react";
import {IconButton} from "../../../features/management-v2/import/inputs";
import {usePrettyFileSize} from "../../../lib/files/usePrettyFileSize";
import {useFileSelect} from "../hooks/useFileSelect";
import BasicText from "../../../components/form-v2/basic-text";
import SaveIcon from "@mui/icons-material/Save";
import {useUploadFile} from "../hooks/useUploadFile";
import {platformAPI} from "../../../api/axiosConfig";
import {useNavigateWithClientID} from "../hooks/useNavigateWithClientID";
import {useSiren} from "../SirenContext";
import {useParams} from "react-router-dom";
import {Layout} from "../Layout";
import {ErrorMessage} from "../ErrorMessage";
import LoadingSpinner from "../../../components/ui/LoadingSpinner";
import {useGetNumber} from "../hooks/useGetNumber";
import {Hotline} from "../typedefs";
import {useGetHotline} from "../hooks/useGetHotline";
import {AudioFileSelect} from "../components/AudioFileSelect";
import {nilObjectID} from "../../../lib/misc/nilObjectID";
import {AudioFilePlayer} from "../components/AudioFilePlayer";

export const HotlineEdit: React.FC = () => {


    const {id} = useParams();
    const {data, isLoading, error} = useGetHotline(id);

    const content = useMemo(() => {
        if (data) return <Form hotline={data}/>

        if (error) return <ErrorMessage text={"error loading contact"}/>

        if (isLoading) return <div className="flex justify-center p-8"><LoadingSpinner/></div>


    }, [
        data, isLoading, error
    ])


    return (
        <Layout menuCurrent={"hotline"}>
            <div className="bg-white shadow-md p-4 flex flex-col gap-4">
                {content}
            </div>
        </Layout>

    )


}


const Form = ({hotline}: { hotline: Hotline }) => {

    const {navigateWithClientID} = useNavigateWithClientID();
    const {clientID} = useSiren()

    const [saveError, setSaveError] = useState<string | null>(null);
    const [saving, setSaving] = useState<boolean>(false);



    const [name, setName] = useState<string>(hotline.name)
    const [audioFileID, setAudioFileID] = useState<string|undefined>(hotline.audioFileID)




    const canSave = useMemo(() => {
        if (name.trim() == "") {
            return false
        }

        if(!audioFileID || audioFileID.trim() == "") {
            return false
        }

        return true


    }, [audioFileID])


    const save = useCallback(async () => {
        setSaving(true);
        setSaveError(null);


        const request = {
            name: name,
            audioFileID: audioFileID,
        }

        try {
            await platformAPI.patch(`api/hotlines/${hotline.id}`, request)
            navigateWithClientID("/siren/hotlines?subPage=hotlines")
        } catch (e) {
            setSaveError("error updating hotline")
        }

        setSaving(false)


    }, [name, audioFileID])

    return (
        <>
            <h1 className={"text-lg font-semibold"}>Edit Hotline</h1>


            <BasicText label={"Name"} value={name} onChange={setName} required/>
            <label className={"mb-1"}>Select Audio File</label>
            <AudioFileSelect clientID={clientID} value={audioFileID}
                             onChange={(f) => setAudioFileID(f?.id)}/>


            {audioFileID && audioFileID != nilObjectID && (
                <div className={"flex flex-col gap-4"}>
                    <AudioFilePlayer id={audioFileID}/>
                </div>
            )}

            <div className={"flex flex-col gap-4"}>


                {canSave && (
                    <IconButton onClick={save} text={"Update"} loading={saving} icon={<SaveIcon/>}/>
                )}
                {saveError && (
                    <p className={"text-center text-red"}>{saveError}</p>
                )}


            </div>
        </>
    )
}
